import { MonoTypeOperatorFunction, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

export interface RetryWithBackoffConfig {
  maxRetries: number;
  initialDelay: number;
  backoffMultiplier?: number;
}

export const retryWithBackoff = <T>({
  maxRetries,
  initialDelay,
  backoffMultiplier = 1,
}: RetryWithBackoffConfig): MonoTypeOperatorFunction<T> =>
  retry({
    count: maxRetries,
    delay: (_, retryIndex) => timer(initialDelay * Math.pow(backoffMultiplier, retryIndex - 1)),
  });
